import message from "./message";
import patientInfo from "./patient-info";
import practiceInfo from "./practice-info";
import rooms from "./rooms";

export default {
  namespaced: true,
  modules: {
    message,
    patientInfo,
    practiceInfo,
    rooms
  }
};
